import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { FollowUp } from "@customTypes/followUp";
import { Pagination } from "@customTypes/index";

import { followUpQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Partial<Pagination> = {
    page: res.data.pagination.page,
    pageSize: res.data.pagination.page_size,
    pageCount: res.data.pagination.page_count,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Partial<FollowUp>[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        c_id,
        consultation_id,
        service_type,
        reason,
        appointment_date,
        follow_up_date,
        patient_id,
        created_at,
        updated_at,
        billing_status,
        doctor_assigned,
        patient_name,
        report_visibility,
      } = res.data.data[i];

      newData.push({
        id: _id,
        cId: c_id,
        consultationId: consultation_id,
        patientId: patient_id,
        appointmentDate: new Date(appointment_date),
        followUpDate: new Date(follow_up_date),
        reason,
        serviceType: service_type,
        createdAt: new Date(created_at),
        updatedAt: new Date(updated_at),
        billStatus: billing_status,
        doctor: {
          id: doctor_assigned?._id,
          fullName: doctor_assigned?.full_name,
        },
        patientName: patient_name,
        consultationVisibility: report_visibility,
      });
    }

    // console.log({ newData, pagination });
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
  doctor?: string;
}

export const useGetFollowUps = ({
  isEnabled = true,
  pagination,
  doctor,
  search = "",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: followUpQKeys.allWithFilters({
      pagination,
      ...(search && { search }),
      ...(doctor && { doctor }),
    }),
    queryFn: () => {
      return api.get("follow-up/", {
        params: {
          ...(search && { search }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
            status: "open",
            doctor_assigned: doctor,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get All Follow-Ups]", res);
      handleErrors(res, "query");
    },
  });
};
